<template>
    <div>
        <!-- 面包屑导航 -->
        <div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item class="mybread" :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item class="mybread">管理员权限</el-breadcrumb-item>
                <el-breadcrumb-item class="mybread">考核活动列表</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <!-- 第一行搜索框和新增按钮 -->
        <el-row type="flex" align="middle" class="myRow">
            <el-col :span="2">班级搜索</el-col>
			<el-col :span="7">
				<el-input placeholder="请输入班级，例如计应21-1" v-model="queryInfo.banji" clearable>
					<el-button slot="append" icon="el-icon-search" @click="mygetActivityList()"></el-button>
				</el-input>
			</el-col>
            <el-col :span="2" :offset="1">用户搜索</el-col>
            <el-col :span="7">
                <el-input placeholder="请输入姓名" v-model="queryInfo.fullName" clearable>
                    <el-button slot="append" icon="el-icon-search" @click="mygetActivityList()"></el-button>
                </el-input>
            </el-col>
        </el-row>
        <el-row  align="middle" class="myRow">
            <el-col :span="3">考核时间选择</el-col>
            <el-col :span="7">
            <el-date-picker
            v-model="dataValue"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            unlink-panels
		    @change="datachange()"
          >
          </el-date-picker>
        </el-col>
          <el-col :span="3" :offset="1">活动状态</el-col>
            <el-col :span="7">
                <el-select v-model="queryInfo.approve" placeholder="请选择" filterable @change="mygetActivityList()">
					<el-option v-for="item in hdzt" :key="item.value" :label="item.label" :value="item.value">
					</el-option>
				</el-select>     
            </el-col>
        </el-row>
        <!-- 用户列表-->
        <el-table border stripe height="620px" :data="activityList" :header-cell-style="{
            background: '#fff1f0', height: '60px', color: '#000000'
        }">
            <el-table-column type="index" label="序号" width="50px"> </el-table-column>
            <el-table-column prop="banji" label="班级" width="100px">
            </el-table-column>
            <el-table-column prop="fullName" label="姓名" width="100px">
            </el-table-column>
            <el-table-column prop="type" label="活动类型" width="180px">
            </el-table-column>
            <el-table-column prop="name" label="活动名称" width="300px">
            </el-table-column>
            <el-table-column prop="date" label="活动日期" width="100px">
            </el-table-column>
            <el-table-column prop="score" label="活动分值" width="80x">
            </el-table-column>
            <el-table-column prop="approve" label="活动状态" width="120x">
            </el-table-column>
            <el-table-column label="操作" width="120px">
                <template slot-scope="scope">
                    <el-button @click="handleApprove(scope.row)" size="small" icon="el-icon-search">审核活动
                    </el-button>
                </template>
            </el-table-column>
            <el-table-column  label="已通过审核人姓名" width="180x">
                <span slot-scope="scope">
					<el-tag effect="plain" type="waring" v-for="item in scope.row.approver"
						 :key=item.fullName>{{ item.fullName }}</el-tag>
				</span>
            </el-table-column>
            <el-table-column prop="approveReason" label="审核理由" width="120x">
            </el-table-column>
        </el-table>
        <!--分页区域-->
		<el-pagination @size-change="handleSizeChange" background @current-change="handleCurrentChange"
			:current-page="approveForm.pageNumber" :page-sizes="[5, 10, 30, 50]" :page-size="approveForm.pageSize"
			layout="total, sizes, prev, pager, next, jumper" :total=count>
		</el-pagination>
        <!-- 审核对话框-->
        <el-dialog title="审核活动" :visible.sync="approveDialogVisible" width="35%">
            <el-form :model="approveForm" :rules="approveFormRules">
                <el-form-item label="活动类型：" prop="type">
                    <span style="margin-left: 5px" >{{ approveForm.type }}</span>
                </el-form-item>
                <el-form-item label="活动名称:" prop="name">
                    <span style="margin-left: 5px" >{{ approveForm.name }}</span>
                </el-form-item>
                <el-form-item label="活动时间:" prop="date">
                    <span style="margin-left: 5px" >{{ approveForm.date }}</span>
                </el-form-item>
                <el-form-item label="活动分值:" prop="score">
                    <span style="margin-left: 5px" >{{ approveForm.score }}</span>
                </el-form-item>
                <el-form-item label="活动附件:">
                    <div v-for="item in approveForm.currentFiles"  :key="item.value" class="img_container">
                        <viewer>
                        <img :src=getFileUrl(approveForm,item.fileName)>
                        </viewer>
                    </div>
                </el-form-item>
                <el-form-item label="" prop="s">
                    <el-radio-group v-model="tempApprove">
                        <el-radio  border v-for="item in radio" :key="item.value" :label="item.label" :value="item.value"></el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="审核理由:" prop="approveReason" v-if="this.tempApprove=='审批不通过'">
                    <el-input v-model="approveReason"  placeholder="请输入审核未通过的理由" >        
                    </el-input>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="approveDialogVisible = false">取 消</el-button>
                <el-button type="primary"    @click="checkUnpassResson()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getToken } from "../../utils/auth";
import { listFiles,  approveActivity, getActivityList } from "@/utils/api.js"
import axios from "axios";
export default {
    data() {
        return {
            queryInfo:{
                banji:'',
                fullName:'',
                dateEnd:'',
                dateStart:'',
                approve:-1,
                pageSize: 30,
				pageNumber: 1,
            },
            approveFormRules: {
				//审批不通过时的必填项
				approveReason: [{
					required: true, message: "审批不通过时，须填写理由"
				},
				
				],
				
			},
            hdzt:[
				{
					value: -1,
					label: '请选择'
				},
				{
					value: "1",
					label: "已通过",
				}, {
					value: "2",
					label: "未通过"
				},{
					value: "0",
					label: "未审核"
				}
			],
            tempApprove:'',
            approveReason:'',
            dataValue:'',
            radio: [
				{
					value: '1',
					label: '审批通过'
				},
				{
					value: '2',
					label: '审批不通过'
				}],
            count:'',
            tempList: [],
            approveInfo:{
                approve:-1,
            },
            //控制审核活动对话框的显示与隐藏
            approveDialogVisible: false,
            approveForm: {
                userId:'',
                type: '',
                name: '',
                date: '',
                score: '',
                id: '',
                fullName:'',
                banji:'',
                fullName:'',
                currentFiles: '',
                approve: -1,
             
                
            },
            activityList: [],

        }
    },
    created() {
        this.mygetActivityList();
       
    },
    methods: {
        mygetActivityList() {      
                    getActivityList(this.queryInfo).then(result => {
							if (result.code === '0000') { 
                                  for (let i in result.data[0]) {
                                    if (result.data[0][i].approve == 0) {
                            result.data[0][i].approve = '未通过';
                        }else if (result.data[0][i].approve == 1) {
                            result.data[0][i].approve = '已通过';
                        } else if (result.data[0][i].approve == 2) {
                            result.data[0][i].approve = '未通过';
                        }
                    }                                                      
								this.activityList = result.data[0];
                                this.count=result.data[1][0];     
							} else {
								console.log(result)
							}
					})
            
            },


        getFileUrl(approveForm,file){
            return axios.defaults.baseURL+'/activity/downloadFile?userId='+approveForm.userId+'&id='+approveForm.id+'&fileName='+file+'&token='+getToken()
        },
   
        async mylistCurrentFiles() {
            let files = []
            await listFiles({ id: this.approveForm.id, userId: this.approveForm.userId }).then(result => {

                if (result.code === '0000') {
                    for (let i in result.data) {
                        files.push(result.data[i])
                    }

                } else {
                    console.log(result)

                }
            })
            return files
        },
        //监听PageSize的长度
		handleSizeChange(newSize) {
			this.queryInfo.pageSize = newSize;
			this.mygetActivityList(this.queryInfo);

		},
		//监听页码值改变的事件
		handleCurrentChange(newPage) {
			this.queryInfo.pageNumber = newPage;
			this.mygetActivityList(this.queryInfo);
			
		},
        checkUnpassResson(){
            if((this.tempApprove=='审批不通过')&&(!this.approveReason)){
                this.$message.error("请设置强密码");
            }else {
                this.myapproveActivity();
            }

        },
        changeRadio() {
            if (this.radio == '1') {
                this.approveForm.approve = 1;
            } else if (this.radio == '2') {
                this.approveForm.approve = 2;
            }
        },
        myapproveActivity() {
            let approveState=-1;
            if(this.tempApprove=='审批通过'){
                approveState=1;
            }else if(this.tempApprove=='审批不通过'){
                approveState=2;
            }
          
            const param = { userId: this.approveForm.userId, approve: approveState, id: this.approveForm.id, approveReason:this.approveReason};
            approveActivity(param).then(result => {
                if (result.code === '0000') {
                    this.activityList.currentFiles = result.data;
                    this.approveDialogVisible = false;
                    this.mygetActivityList();
                
                } else {
                    console.log(result);
            
                }
            })

        },

        doClose() {
            this.userList.forEach((ele, index) => {
                this.$refs[`popover-${index}`].doClose()
            })
        },
        async handleApprove(row) {
           console.log(row.approver);
        
            this.approveForm = row;
            this.approveForm.currentFiles = await this.mylistCurrentFiles()
            this.approveDialogVisible = true;

        },
        datachange(){
			this.queryInfo.dateStart=this.dataValue[0];
			this.queryInfo.dateEnd=this.dataValue[1];
			this.mygetActivityList();
		
		}

    }
}
</script>

<style>
.title {
    font-size: 20px;
}

.basicInfo {
    height: 300px;
    width: 500px;
    background-color: bisque;
}

.img_container img{
    height:200px;
    width: 200px;
}
.el-button--primary {
    background-color: darkred;
    color: #fff;
    border-color: darkred;
    width: 130px;
    font-size: 18px;
}

.el-popover {
    padding: 10px !important;
    font-size: 18px !important;
    border: 1px solid gray !important;
    background-color: #f4eded !important;
    height: 50px;
}

.el-upload {
    width: 100%;
}

.el-upload .el-upload-dragger {
    width: 100%;
}

.el-breadcrumb .el-breadcrumb__inner {
    color: grey;
    font-size: 18px;
}

.myRow {
    margin-top: 50px;
    margin-bottom: 30px;
    margin-left: 20px;
}

.el-tag+.el-tag {
    margin-left: 10px;
}
</style>